import { GetStaticProps } from 'next';

import { AdditionalInfoLayout } from '@components/AdditionalInfoLayout';
import { ContactForm } from '@components/ContactForm';
import { InquiriesInformation } from '@components/InquiriesInformation';

import { getContactPage } from '@data/sanity/queries';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { CmsContactPageDocument, CmsPageMetadata } from '@interfaces/common';
import { breakpoints } from '@utils/device';
import { withSiteWideData } from '@utils/page';

interface ContactPageProps {
	metadata: CmsPageMetadata;
	contactPage: CmsContactPageDocument;
}

const ContactPage: React.VFC<ContactPageProps> = ({
	metadata,
	contactPage: { contactForm, inquiriesInfo },
}) => {
	const isMediaMinLarge = useMediaQuery(breakpoints.lg);

	return (
		<AdditionalInfoLayout title={metadata.title}>
			{isMediaMinLarge ? (
				<InquiriesInformation inquiries={inquiriesInfo} />
			) : null}

			{/* HACK: The contact form is not rendered in the falsy expression of the above conditional to avoid input reset on browser resize */}
			<ContactForm formFields={contactForm.formFields} />

			{!isMediaMinLarge ? (
				<InquiriesInformation inquiries={inquiriesInfo} />
			) : null}
		</AdditionalInfoLayout>
	);
};

export const getStaticProps: GetStaticProps =
	withSiteWideData<ContactPageProps>(async ({ locale }) => {
		const contactPage = await getContactPage(locale);

		if (!contactPage) {
			return {
				notFound: true,
			};
		}

		return {
			props: {
				metadata: contactPage.metadata || null,
				hasNewsLetterSection: false,
				contactPage,
			},
		};
	});

export default ContactPage;
